import React, { FC, ReactElement } from 'react';
import { TextStyle } from 'react-native';
import { Typography, IStyleProp, defaultStyle, BodyType } from '@fkhplus/common/src/components/atoms/Text/style';

export interface ITextStyle extends IStyleProp {
    type?: BodyType;
}

interface ITextProps {
    textStyle?: ITextStyle;
    style?: TextStyle;
}

export const Text: FC<ITextProps> = (props): ReactElement => {
    const defaultType = 'bodyRegular'
    const { children, textStyle = { ...defaultStyle, type: defaultType }, style } = props;
    const styleProp: IStyleProp = {
        fontWeight: textStyle.fontWeight,
        fontType: textStyle.fontType,
        color: textStyle.color,
    }

    return (
        <Typography style={style} type={textStyle.type || defaultType} styleProp={textStyle} allowFontScaling={false}>
            {children}
        </Typography>
    );
};
